module.exports = __webpack_public_path__ + "img/objLine.ea5b368f.svg";